'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsCta = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _colors = require('constants/colors');

var _CallToAction = require('components/CallToAction');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CmsCta = exports.CmsCta = function (_PureComponent) {
  (0, _inherits3.default)(CmsCta, _PureComponent);

  function CmsCta() {
    (0, _classCallCheck3.default)(this, CmsCta);
    return (0, _possibleConstructorReturn3.default)(this, (CmsCta.__proto__ || (0, _getPrototypeOf2.default)(CmsCta)).apply(this, arguments));
  }

  (0, _createClass3.default)(CmsCta, [{
    key: 'ctaColor',
    value: function ctaColor(color, isPrimary) {
      return _colors.CTA_COLOR_BY_NAME[color] || isPrimary && _colors.CTA_COLOR_BY_NAME.primary_solid || _colors.CTA_COLOR_BY_NAME.default;
    }
  }, {
    key: 'parseProps',
    value: function parseProps(_ref) {
      var children = _ref.children,
          copy = _ref.copy,
          extraProps = (0, _objectWithoutProperties3.default)(_ref, ['children', 'copy']);

      return (0, _extends3.default)({}, extraProps, {
        children: children || copy
      });
    }
  }, {
    key: 'renderCallToAction',
    value: function renderCallToAction(action) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;

      return _react2.default.createElement(_CallToAction.CallToAction, (0, _extends3.default)({}, this.parseProps(props), {
        action: action
      }));
    }

    /**
     * The URL CTA has some legacy color handling to normalize
     * the colors to our standard CTA colors.
     */

  }, {
    key: 'renderUrlCallToAction',
    value: function renderUrlCallToAction() {
      var _props = this.props,
          color = _props.color,
          extraClass = _props.extraClass,
          isPrimary = _props.isPrimary,
          url = _props.url,
          extraProps = (0, _objectWithoutProperties3.default)(_props, ['color', 'extraClass', 'isPrimary', 'url']);


      var ctaClassName = (0, _classnames2.default)(extraClass, this.ctaColor(color, isPrimary));

      return this.renderCallToAction(_CallToAction.ACTIONS.LINK, (0, _extends3.default)({}, extraProps, {
        to: url,
        extraClass: ctaClassName
      }));
    }

    /**
     * The YouTube CTA has some legacy color handling to normalize
     * the colors to our standard CTA colors.
     */

  }, {
    key: 'renderYoutubeCallToAction',
    value: function renderYoutubeCallToAction() {
      var _classNames;

      var _props2 = this.props,
          color = _props2.color,
          extraClass = _props2.extraClass,
          isPrimary = _props2.isPrimary,
          theme = _props2.theme,
          videoId = _props2.videoId,
          extraProps = (0, _objectWithoutProperties3.default)(_props2, ['color', 'extraClass', 'isPrimary', 'theme', 'videoId']);


      var extraClassWithColors = (0, _classnames2.default)(extraClass, this.ctaColor(color, isPrimary), (_classNames = {}, (0, _defineProperty3.default)(_classNames, _colors.CTA_COLOR_BY_NAME.marketing_white, !color && theme === 'light'), (0, _defineProperty3.default)(_classNames, _colors.CTA_COLOR_BY_NAME.primary, !color && theme === 'dark'), _classNames));

      return this.renderCallToAction(_CallToAction.ACTIONS.SHOW_MODAL, (0, _extends3.default)({}, extraProps, {
        extraClass: extraClassWithColors,
        modalName: 'YouTubeVideoModal',
        modalProps: { videoId: videoId }
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      switch (this.props.type) {
        case _constants.CMS_CTA_TYPES.OFFER_CHECKOUT:
          return this.renderCallToAction(_CallToAction.ACTIONS.OFFER_CHECKOUT);
        case _constants.CMS_CTA_TYPES.RAF:
          return this.renderCallToAction(_CallToAction.ACTIONS.SHOW_FRIENDBUY_WIDGET);
        case _constants.CMS_CTA_TYPES.YOUTUBE_VIDEO:
          return this.renderYoutubeCallToAction();
        case _constants.CMS_CTA_TYPES.URL:
          return this.renderUrlCallToAction();
        default:
          return null;
      }
    }
  }]);
  return CmsCta;
}(_react.PureComponent);

CmsCta.propTypes = {
  color: _propTypes2.default.string,
  copy: _propTypes2.default.string,
  children: _propTypes2.default.node,
  extraClass: _propTypes2.default.string,
  isPrimary: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  promotionAlias: _propTypes2.default.string,
  theme: _propTypes2.default.string,
  type: _propTypes2.default.string,
  url: _propTypes2.default.string,
  videoId: _propTypes2.default.string
};